import { z } from "zod";

// ── Proposal Discount (application/audit record) ────────────

export const ProposalDiscountSchema = z.object({
  id: z.string().uuid().describe("ID"),
  business_id: z.string().uuid().describe("Business"),
  account_id: z.string().uuid().nullable().describe("Account"),
  proposal_id: z.string().uuid().describe("Proposal"),
  proposal_item_id: z.string().uuid().nullable().describe("Proposal Item"),
  promotion_id: z.string().uuid().nullable().describe("Promotion"),
  discount_type: z.enum(["percentage", "fixed"]).describe("Discount Type"),
  discount_value: z.number().describe("Discount Value"),
  discount_amount: z.number().describe("Discount Amount"),
  label: z.string().describe("Label"),
  label_override: z.string().nullable().describe("Label Override"),
  approval_status: z
    .enum(["auto_approved", "pending", "approved", "rejected"])
    .describe("Approval Status"),
  approved_by: z.string().uuid().nullable().describe("Approved By"),
  approved_at: z.string().nullable().describe("Approved At"),
  applied_by: z.string().uuid().nullable().describe("Applied By"),
  applied_at: z.string().describe("Applied At"),
  reason: z.string().nullable().describe("Reason"),
  created_at: z.string().describe("Created At"),
});

export const ApplyPromotionSchema = z.object({
  promotion_id: z.string().uuid(),
  proposal_item_id: z.string().uuid().nullable().optional(),
  label_override: z.string().nullable().optional(),
});

export const ApplyManualDiscountSchema = z
  .object({
    discount_type: z.enum(["percentage", "fixed"]),
    discount_value: z.number().positive(),
    proposal_item_id: z.string().uuid().nullable().optional(),
    label_override: z.string().nullable().optional(),
    reason: z.string().nullable().optional(),
  })
  .refine((d) => d.discount_type !== "percentage" || d.discount_value <= 100, {
    message: "Percentage discount cannot exceed 100",
    path: ["discount_value"],
  });

export type ProposalDiscount = z.infer<typeof ProposalDiscountSchema>;
